module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#youtube",
      toString: function () {
        return this.url;
      }
    }